'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.renderComponents = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _uiAuthorHeader = require('@spp/ui-author-header');

var _uiAuthorHeader2 = _interopRequireDefault(_uiAuthorHeader);

var _uiBlockquote = require('@spp/ui-blockquote');

var _uiBlockquote2 = _interopRequireDefault(_uiBlockquote);

var _uiBreak = require('@spp/ui-break');

var _uiBreak2 = _interopRequireDefault(_uiBreak);

var _uiByline = require('@spp/ui-byline');

var _uiByline2 = _interopRequireDefault(_uiByline);

var _uiEmbedContent = require('@spp/ui-embed-content');

var _uiEmbedContent2 = _interopRequireDefault(_uiEmbedContent);

var _uiExternalLink = require('@spp/ui-external-link');

var _uiExternalLink2 = _interopRequireDefault(_uiExternalLink);

var _uiFactbox = require('@spp/ui-factbox');

var _uiFactbox2 = _interopRequireDefault(_uiFactbox);

var _uiGrade = require('@spp/ui-grade');

var _uiGrade2 = _interopRequireDefault(_uiGrade);

var _uiHeadline = require('@spp/ui-headline');

var _uiHeadline2 = _interopRequireDefault(_uiHeadline);

var _uiImage = require('@spp/ui-image');

var _uiImage2 = _interopRequireDefault(_uiImage);

var _uiLabel = require('@spp/ui-label');

var _uiLabel2 = _interopRequireDefault(_uiLabel);

var _uiLeadText = require('@spp/ui-lead-text');

var _uiLeadText2 = _interopRequireDefault(_uiLeadText);

var _uiList = require('@spp/ui-list');

var _uiList2 = _interopRequireDefault(_uiList);

var _uiSubheading = require('@spp/ui-subheading');

var _uiSubheading2 = _interopRequireDefault(_uiSubheading);

var _uiSubtitle = require('@spp/ui-subtitle');

var _uiSubtitle2 = _interopRequireDefault(_uiSubtitle);

var _uiTeaserSmall = require('@spp/ui-teaser-small');

var _uiTeaserSmall2 = _interopRequireDefault(_uiTeaserSmall);

var _uiText = require('@spp/ui-text');

var _uiText2 = _interopRequireDefault(_uiText);

var _hyperionStylizr = require('@spp/hyperion-stylizr');

var _renderComponents = require('./render-components');

var _renderComponents2 = _interopRequireDefault(_renderComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStylizrComposer = (0, _hyperionStylizr.stylizrComposer)((0, _hyperionStylizr.getStylizrInstance)());

var StylizedText = defaultStylizrComposer(_uiText2.default);
var StylizedLeadText = defaultStylizrComposer(_uiLeadText2.default);
var StylizedSubheading = defaultStylizrComposer(_uiSubheading2.default);
var StylizedSubtitle = defaultStylizrComposer(_uiSubtitle2.default);
var StylizedList = defaultStylizrComposer(_uiList2.default);

var StylizedFactboxText = defaultStylizrComposer(_uiFactbox.FactboxText);
var StylizedFactboxBlockquote = defaultStylizrComposer(_uiFactbox.FactboxBlockquote);
var StylizedFactboxHeadline = defaultStylizrComposer(_uiFactbox.FactboxHeadline);
var StylizedFactboxLead = defaultStylizrComposer(_uiFactbox.FactboxLead);
var StylizedFactboxList = defaultStylizrComposer(_uiFactbox.FactboxList);
var StylizedFactboxSubheading = defaultStylizrComposer(_uiFactbox.FactboxSubheading);
var StylizedFactboxSubtitle = defaultStylizrComposer(_uiFactbox.FactboxSubtitle);

var VideoEmbedContent = function VideoEmbedContent(props) {
    return _react2.default.createElement(_uiEmbedContent2.default, (0, _extends3.default)({ isVideo: true }, props));
};

exports.default = {
    authorHeader: {
        default: { component: _uiAuthorHeader2.default }
    },
    breakpoint: {
        default: { component: _uiBreak2.default }
    },
    fact: {
        default: {
            component: function component(props) {
                return _react2.default.createElement(_uiFactbox2.default, (0, _extends3.default)({}, props, { expandBy: 'button' }));
            },
            children: {
                text: {
                    default: { component: StylizedFactboxText },
                    blockquote: { component: StylizedFactboxBlockquote },
                    title: { component: StylizedFactboxHeadline },
                    lead: { component: StylizedFactboxLead },
                    subtitle: { component: StylizedFactboxSubtitle },
                    subheading: { component: StylizedFactboxSubheading },
                    heading: { component: StylizedSubheading }
                },
                list: {
                    default: { component: StylizedFactboxList }
                }
            }
        }
    },
    byline: {
        default: { component: _uiByline2.default }
    },
    grade: {
        default: { component: _uiGrade2.default }
    },
    image: {
        default: { component: _uiImage2.default }
    },
    label: {
        default: { component: _uiLabel2.default }
    },
    list: {
        default: { component: StylizedList },
        ordered: { component: function component(props) {
                return _react2.default.createElement(StylizedList, (0, _extends3.default)({}, props, { subtype: 'ordered' }));
            } }
    },
    teaser: {
        default: {
            component: function component(props) {
                return _react2.default.createElement(
                    'aside',
                    null,
                    _react2.default.createElement(_uiTeaserSmall2.default, (0, _extends3.default)({}, props, {
                        stylizr: (0, _hyperionStylizr.getStylizrInstance)('teaser', _hyperionStylizr.rules.STYLE_HANDLERS)
                    }))
                );
            }
        }
    },
    text: {
        default: { component: StylizedText },
        blockquote: { component: _uiBlockquote2.default },
        lead: { component: StylizedLeadText },
        title: { component: _uiHeadline2.default },
        subtitle: { component: StylizedSubtitle },
        heading: { component: StylizedSubheading }
    },
    url: {
        default: {
            /* eslint-disable react/prop-types */
            component: function component(_ref) {
                var url = _ref.url,
                    _ref$title = _ref.title;
                _ref$title = _ref$title === undefined ? {} : _ref$title;
                var titleValue = _ref$title.value;
                return _react2.default.createElement(
                    _uiExternalLink2.default,
                    { href: url },
                    ' ',
                    titleValue || url,
                    ' '
                );
            }
            /* eslint-enable react/prop-types */
        },
        datawrapper: { component: _uiEmbedContent2.default },
        'facebook-post': { component: _uiEmbedContent2.default },
        'facebook-video': { component: VideoEmbedContent },
        'imgur-image': { component: _uiEmbedContent2.default },
        infogram: { component: _uiEmbedContent2.default },
        'instagram-image': { component: _uiEmbedContent2.default },
        playbuzz: { component: _uiEmbedContent2.default },
        'polldaddy-poll': { component: _uiEmbedContent2.default },
        scribd: { component: _uiEmbedContent2.default },
        'soundcloud-audio': { component: _uiEmbedContent2.default },
        'spotify-audio': { component: _uiEmbedContent2.default },
        'twitter-tweet': { component: _uiEmbedContent2.default },
        'vimeo-video': { component: VideoEmbedContent },
        'youtube-video': { component: VideoEmbedContent }
    }
};
exports.renderComponents = _renderComponents2.default;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/lib/cjs/index.js
 ** module id = 498
 ** module chunks = 1
 **/